import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { throttle } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
export function useTheme() {
  var isWatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var htmlDomRef = useRef(document.querySelector("html"));
  var _useState = useState(function () {
      if (isWatch) {
        var htmlDom = document.querySelector("html");
        return {
          theme: htmlDom.className.includes("dark") ? "dark" : "light",
          ticker: htmlDom.className.includes("ticker-reversed") ? true : false
        };
      }
      return null;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    theme = _useState2[0],
    setThemeDispatch = _useState2[1];
  var setTheme = useCallback(function (params) {
    var _htmlDomRef$current;
    var list = (_htmlDomRef$current = htmlDomRef.current) === null || _htmlDomRef$current === void 0 ? void 0 : _htmlDomRef$current.classList;
    if (list) {
      list.add("theme-".concat(params.theme));
      list.add("".concat(params.theme));
      if (params.theme === "dark") {
        list.remove("light");
        list.remove("theme-light");
      } else {
        list.remove("dark");
        list.remove("theme-dark");
      }
      if (params.ticker) {
        list.add("ticker-reversed");
        list.remove("ticker");
      } else {
        list.remove("ticker-reversed");
        list.add("ticker");
      }
    }
  }, []);
  useEffect(function () {
    if (isWatch) {
      var htmlDom = document.querySelector("html");
      var cb = throttle(function callback(mutationList, observer) {
        if (mutationList.some(function (mutation) {
          return mutation.type === "attributes" && mutation.attributeName === "class";
        })) {
          setThemeDispatch(function () {
            return {
              theme: htmlDom.className.includes("dark") ? "dark" : "light",
              ticker: htmlDom.className.includes("ticker-reversed") ? true : false
            };
          });
        }
      });
      var observer = new MutationObserver(cb);
      observer.observe(htmlDom, {
        attributes: true
      });
      return function () {
        observer.disconnect();
      };
    }
  }, []);
  return [theme, setTheme];
}